import React from 'react';
import '../assets/styles/about.css';
import SEOHelmet from '../components/common/SEOHelmet';

const About = () => {
  return (
    <>
      <SEOHelmet
        title="About Matrix IT - IT Solutions Provider in Cuttack, Odisha"
        description="Matrix IT is an IT solutions provider based in Cuttack, Odisha, offering laptop & desktop sales, server infrastructure, networking, and AMC. Our mission is to ensure seamless, secure, and efficient IT operations for businesses of all sizes."
        keywords="about Matrix IT, IT solutions Cuttack, IT company Odisha, IT infrastructure, networking, AMC, cybersecurity"
        canonicalUrl="https://www.matrixit.co.in/about"
      />
      <div className="about-page">
        <section className="about-hero">
          <div className="container">
            <h1>About Matrix IT</h1>
            <p>Your Trusted IT Solutions Partner in Cuttack, Odisha</p>
            <p className="hero-subtitle">
              Delivering high-quality, scalable, and innovative IT solutions with a focus on reliability and cybersecurity
            </p>
            <button className="hero-cta">Explore Our Services</button>
          </div>
        </section>

        <section className="company-story">
          <div className="container">
            <div className="story-grid">
              <div className="story-text">
                <h2>Our Story</h2>
                <p >
                  Matrix IT is an IT solutions provider based in Cuttack, Odisha, offering a wide range of services including laptop & desktop sales, server infrastructure, networking, and Annual Maintenance Contracts (AMC). Our mission is to ensure seamless, secure, and efficient IT operations for businesses of all sizes.
                </p>
                <p >
                  We serve a diverse clientele including U3S Engitech, Sambeet Equipments, Vikrant Engineers, Navya Motors, L&T Tangi Project, and many more businesses across Odisha and beyond. Our team of experts works tirelessly to deliver solutions that address the unique challenges faced by modern businesses.
                </p>
                <p >
                  From robust IT infrastructure design to comprehensive cybersecurity solutions, Matrix IT stands committed to helping businesses overcome IT challenges including unstable infrastructure, lack of proactive maintenance, cybersecurity threats, and outdated hardware/software inefficiencies.
                </p>
              </div>
              <div className="story-image">
                <div className="image-placeholder"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="mission-vision">
          <div className="container">
            <div className="mv-grid">
              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                  To deliver high-quality, scalable, and innovative IT solutions with a focus on reliability, cybersecurity, proactive support, and cost-effectiveness. We empower businesses to achieve seamless IT operations that drive growth and success.
                </p>
              </div>
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  To become a globally trusted leader in IT services, setting new standards in technology excellence, customer satisfaction, and innovation while helping businesses of all sizes thrive in the digital age.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="milestones">
          <div className="container">
            <h2>Key Milestones</h2>
            <div className="milestone-grid">
              <div className="milestone-card">
                <h3>2010</h3>
                <p>Matrixit founded in Silicon Valley</p>
              </div>
              <div className="milestone-card">
                <h3>2015</h3>
                <p>Expanded to Europe and Asia</p>
              </div>
              <div className="milestone-card">
                <h3>2020</h3>
                <p>Launched AI-driven solutions</p>
              </div>
              <div className="milestone-card">
                <h3>2025</h3>
                <p>Serving 1000+ global clients</p>
              </div>
            </div>
          </div>
        </section>

        <section className="team">
          <div className="container">
            <h2>Key Problems We Solve</h2>
            <div className="team-grid">
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h3>John Doe</h3>
                  <p className="position">CEO & Founder</p>
                  <p>20+ years shaping tech industry</p>
                  <p className="bio">Visionary leader driving Matrixit's global success</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h3>Jane Smith</h3>
                  <p className="position">CTO</p>
                  <p>Expert in AI and cloud solutions</p>
                  <p className="bio">Architecting our technological future</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h3>Mike Johnson</h3>
                  <p className="position">Head of Innovation</p>
                  <p>Pioneering next-gen solutions</p>
                  <p className="bio">Leading R&D for groundbreaking tech</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h3>Sarah Williams</h3>
                  <p className="position">COO</p>
                  <p>Streamlining global operations</p>
                  <p className="bio">Ensuring excellence in execution</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h3>David Lee</h3>
                  <p className="position">CFO</p>
                  <p>Financial strategist</p>
                  <p className="bio">Guiding fiscal growth and stability</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="values">
          <div className="container">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">💻</div>
                <h3>Technical Expertise & Innovation</h3>
                <p>Staying updated with the latest tech trends and solutions</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h3>Customer-Centric Approach</h3>
                <p>Tailored solutions and personalized support for every client</p>
              </div>
              <div className="value-card">
                <div className="value-icon">⚡</div>
                <h3>Reliability & Uptime Assurance</h3>
                <p>Minimizing downtime through proactive maintenance</p>
              </div>
              <div className="value-card">
                <div className="value-icon">💰</div>
                <h3>Cost-Effective & Scalable</h3>
                <p>Solutions that grow with your business needs</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🔒</div>
                <h3>Security & Compliance</h3>
                <p>Protecting your data with advanced cybersecurity measures</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;